var map = {
	"./operation/index.jsx": 534,
	"./xml/index.js": 1303
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2754;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/registration/product/inventory/modify \.\/[^\/]+\/index\.jsx?$
// module id = 2754
// module chunks = 0